import { render, staticRenderFns } from "./FilePreviewDialog.vue?vue&type=template&id=0c8e33c4"
import script from "./FilePreviewDialog.vue?vue&type=script&lang=ts"
export * from "./FilePreviewDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports